import React, { FC } from 'react';
import cn from 'classnames';
import { FiPlus } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import { useFileDropzone } from './hook/useFileDropzone';
import css from './styles.module.scss';

interface IFileDropzoneProps {
  // Колбэк, который сообщает наружу о текущем списке файлов
  onFilesChange: (files: File[]) => void;
  /** Разрешаем ли множественность загрузки */
  multiple?: boolean;
}

const FileDropzone: FC<IFileDropzoneProps> = ({
  onFilesChange,
  multiple = false,
}) => {
  const { t } = useTranslation();
  const {
    handleDragEnter,
    handleDragOver,
    handleDragLeave,
    handleDrop,
    isDragActive,
    inputRef,
    handleInputChange,
    handleClick,
  } = useFileDropzone({ onFilesChange });

  return (
    <>
      <input
        ref={inputRef}
        type="file"
        multiple={multiple}
        hidden
        onChange={handleInputChange}
      />
      <div
        onClick={handleClick}
        onDragEnter={handleDragEnter}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
        className={cn(css.dropzone, 'FileDropzone', {
          _isActive: isDragActive,
        })}
      >
        <div className={css.dropzone_label}>
          <FiPlus />
          <span>{t(`select_or_drop`)}</span>
        </div>
      </div>
    </>
  );
};

export default FileDropzone;
